<template>
	<div class="wf-input">
		<Input :value="value" :placeholder="placeholder" @on-change="handleChange" @on-enter="handleEnter"></Input>
	</div>
</template>

<script>
import Input from 'iview/src/components/input';

export default {
	components: {
		Input
	},
	data() {
		return {

		}
	},
	props: {
		value: {
			type: String,
			default: ""
		},

		placeholder: {
			type: String,
			default: ""
		}
	},
	methods: {
		// 输入框改变事件
		handleChange(event) {
			this.$emit('change', event.target.value)
		},

		// 输入框回车事件
		handleEnter(event) {
			this.$emit('enter', event)
		}
	}
}
</script>

<style lang="scss" scoped>
.wf-input {
	/deep/ .ivu-input {
		height: 30px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/input/input.vue